import { QueryClient } from '@tanstack/react-query';

/**
 * Clears and refetches organization-related cache from both React Query and Zustand store
 * This is commonly used after updating organization settings to ensure UI stays in sync
 *
 * @param queryClient - React Query client instance
 * @param fetchOrganization - Zustand store's fetchOrganization function
 * @returns Promise that resolves when both caches are cleared
 */
export const clearOrganizationCache = async (
  queryClient: QueryClient,
  fetchOrganization: (force?: boolean) => Promise<void>
): Promise<void> => {
  // Wait for React Query to finish refetching organization data
  await queryClient.refetchQueries({ queryKey: ['Organizations'] });

  // ALSO refetch the Zustand store (it's separate from React Query!)
  await fetchOrganization(true);
};

/**
 * Invalidates organization queries in React Query cache
 * Use this for a lighter touch when you don't need to force refetch Zustand store
 *
 * @param queryClient - React Query client instance
 */
export const invalidateOrganizationQueries = (queryClient: QueryClient): void => {
  queryClient.invalidateQueries({ queryKey: ['Organizations'] });
};
